<template>
  <v-card class="text-xs-center">
    <h1 class="text-pagename">Bank List</h1>
    <banklist />
  </v-card>
</template>
<script>
import banklist from "@/components/back-office/ManagerUserManage/BanklistTable.vue";
import { mapState } from "vuex";
export default {
  components: {
    banklist,
  },
};
</script>
